export default __webpack_public_path__ + "static/shooting-wsg-5546eea9202eabd9064ceb552db9c3f8.jpg";